import { Text, Box, Heading, Flex } from '@chakra-ui/react';
import Button from '../../components/Button/Button';
export interface PromoBarProps {
    title: JSX.Element | string;
    version: 'green' | 'black' | 'orange';
    eyebrow?: string;
    discountPrice?: string;
    text?: string;
    dueTo?: string;
    buttonText: string;
    href: string;
}

const PromoBar: React.FC<PromoBarProps> = ({
    version,
    title,
    eyebrow,
    discountPrice,
    text,
    dueTo,
    buttonText,
    href,
}) => {
    return (
        <Box
            display={'flex'}
            flexDirection={{ base: 'column', lg: 'row' }}
            position="relative"
            py={'50px'}
            px={{ base: '0', lg: '50px' }}
            alignItems={'center'}
            justifyContent={'space-between'}
            _before={{
                content: '""',
                position: 'absolute',
                height: '100%',
                top: 0,
                width: '100vw',
                marginLeft: '50%',
                left: '-50vw',
                zIndex: -2,
                backgroundColor:
                    version === 'green' ? '#D4F7E5' : version === 'black' ? 'dark.5' : '#E25E2E',
            }}
        >
            <Flex
                flexDirection={'column'}
                paddingRight={{ base: '0', lg: '120px' }}
                marginBottom={{ base: 8, lg: '0' }}
                textAlign={{
                    base: 'center',
                    lg: 'left',
                }}
            >
                {eyebrow && (
                    <Text
                        fontSize={'1.5rem'}
                        lineHeight={'2rem'}
                        marginBottom={'.3125rem'}
                        fontWeight={'900'}
                        color={
                            version === 'green'
                                ? '#1AAC7A'
                                : version === 'black'
                                ? '#E25E2E'
                                : 'dark.5'
                        }
                    >
                        {eyebrow}{' '}
                        <Text ml={'4px'} as={'span'} textDecoration={'line-through'}>
                            {discountPrice}
                        </Text>
                    </Text>
                )}
                <Heading
                    as={'h2'}
                    color={version === 'green' ? 'dark.5' : 'white'}
                    fontWeight={'400'}
                    fontSize={'1.25rem'}
                    lineHeight={'2rem'}
                >
                    {title}
                </Heading>
                <Text color={version === 'green' ? 'dark.5' : 'white'} fontSize={'xl'}>
                    {text}
                </Text>
            </Flex>
            <Flex
                flexDirection={'column'}
                paddingLeft={{ base: '0', lg: '50px' }}
                justifyContent={'center'}
                alignItems={'center'}
            >
                <Box marginBottom={'5px'}>
                    <Button
                        href={href}
                        target="_blank"
                        style={version === 'black' ? 'outline-reverted' : 'default'}
                    >
                        <Text whiteSpace={'pre'}>{buttonText}</Text>
                    </Button>
                </Box>
                <Text textAlign={'center'} color={version === 'green' ? 'dark.5' : 'white'}>
                    {dueTo}
                </Text>
            </Flex>
        </Box>
    );
};

export default PromoBar;
